import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;

  ${({display, theme}) => {
    if (display) {
      return `svg {
        color: ${theme.colors.red300};
      };
      span {
        color: ${theme.colors.red300};
      };
      `
    } else {
      return `  & svg {
        display: none;
      };
      & span {
        color: transparent;
      };`
    }
  }}


`

export const Span = styled.span`
  font-size: 0.7rem;
  font-weight: 400;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

